<script setup>

import IdleTime from "src/composables/IdleTime.js";
import { computed, onMounted, ref, watch } from "vue";
import { useAuth0 } from "@auth0/auth0-vue";
import * as Sentry from "@sentry/browser";
import Intercom from "src/composables/Intercom";
import Orders from "src/composables/Orders";
import { Cookies, LocalStorage } from "quasar";
import { useRouter } from "vue-router";
import Supabase from "src/composables/Supabase";


defineProps({
  sticky: Boolean
})
const logo_url = `${ process.env.ASSETS_URL }images/comparepower.svg`;
const { loginWithRedirect, logout, isAuthenticated, user } = useAuth0();
const { call_intercom } = Intercom();
const { order } = Orders();
const router = useRouter()

const this_year = computed(() => {
  return new Date().getFullYear();
})

watch([user], () => {
  if (user.value) {
    Sentry.setUser({ id: user.value.sub, ...user.value })
    call_intercom({ command: 'shutdown' })
    call_intercom({
      command: 'boot',
      props: {
        app_id: "fopafuic",
        ...user.value
      }
    })
  }
})

const fid = ref(null);
const cid = ref(null);

onMounted(() => {
  call_intercom({
    command: 'boot',
    props: {
      app_id: 'fopafuic'
    }
  })
  fid.value = LocalStorage.getItem('cp_fpid');
  cid.value = LocalStorage.getItem('cid');
})


const login = () => {
  loginWithRedirect()
}
const logout_action = () => {
  call_intercom({ command: 'shutdown' })
  logout({ returnTo: window.location.origin })
}

const route_to_home = () => {
  router.push('/');
}

const { supabase, is_authenticated, user: supabase_user, picture } = Supabase()
const sign_out = async () => {
  await supabase.auth.signOut()
}

const members_url = process.env.MEMBERS_URL
</script>

<template>
  <q-layout view="hHh lpR fFf">
    <q-header class="bg-white" data-html2canvas-ignore>
      <slot name="header_top"></slot>
      <q-toolbar style="border-bottom: 1px solid gainsboro" class="q-pa-sm">
        <q-toolbar-title class="flex justify-between items-center">
          <div @click="route_to_home" class="cursor-pointer">
            <img :src="logo_url" class="flex items-center" style="min-height: 40px">
          </div>
          <div v-if="is_authenticated">
            <q-btn-dropdown flat dropdown-icon="none">
              <template v-slot:label>
                <q-avatar>
                  <q-img :src="picture"></q-img>
                </q-avatar>
              </template>

              <div class="text-100">
                <div class="q-py-sm q-px-md">
                  <div class="text-weight-bold text-grey-9"> {{ supabase_user.user_metadata.full_name }}</div>
                  <div class="text-sm text-grey-9"> {{ supabase_user.user_metadata.email }}</div>
                </div>
                <a :href="members_url" class="q-py-sm q-px-md text-grey-9 text-weight-medium user_menu_item"
                   style="text-decoration: none; display: block; border-top: 1px solid #f3f4f6">
                  Dashboard
                </a>
                <a :href="`${members_url}/account`"
                   class="q-py-sm q-px-md text-grey-9 text-weight-medium user_menu_item"
                   style="text-decoration: none; display: block">
                  My Account
                </a>
                <a @click="sign_out" class="q-py-sm q-px-md text-grey-9 text-weight-medium user_menu_item"
                   style="text-decoration: none; display: block; cursor: pointer; border-top: 1px solid #f3f4f6">
                  Sign Out
                </a>
              </div>

            </q-btn-dropdown>
          </div>
          <div v-else>
            <q-btn :href="`${members_url}/login`" color="primary">Login</q-btn>
<!--            <q-btn-dropdown flat dropdown-icon="none">-->
<!--              <template v-slot:label>-->
<!--                <q-icon size="xl" class="text-primary" name="account_circle"></q-icon>-->
<!--              </template>-->

<!--              <div class="text-100" style="width: 250px">-->
<!--                <a :href="`${members_url}/login`" class="q-py-sm q-px-md text-grey-9 text-weight-medium user_menu_item"-->
<!--                   style="text-decoration: none; display: block">-->
<!--                  Login-->
<!--                </a>-->
<!--              </div>-->

<!--            </q-btn-dropdown>-->
          </div>
        </q-toolbar-title>
      </q-toolbar>
    </q-header>

    <q-page-container>
      <slot name="main">
        <router-view/>
      </slot>
    </q-page-container>

    <slot name="footer"></slot>

    <div class="bg-blue-grey-1 q-pt-xl">
      <div class="text-center q-px-md">
        © 2009-{{ this_year }} ComparePower, LLC. All rights reserved. ComparePower® is a registered trademark of
        Compare Power, LLC.
      </div>
      <div class="text-center">
        ComparePower.com is operated on behalf of Compare Power LLC | PUCT Reg #BR190020
      </div>
      <div class="row justify-center q-gutter-md">
        <a href="https://comparepower.com/privacy" target="_blank" class="text-black text-weight-regular">Privacy
          Policy</a>
        <a href="https://comparepower.com/terms" target="_blank" class="text-black text-weight-regular">Terms of
          Service</a>
      </div>
      <div v-if="isAuthenticated" class="text-center">
        <q-avatar size="sm">
          <q-img :src="user.picture"></q-img>
        </q-avatar>
        <q-btn no-caps flat icon="logout" color="primary" @click="logout_action"></q-btn>
      </div>
      <div v-else class="row justify-center">
        <q-btn no-caps flat icon="login" color="primary" @click="login"></q-btn>
      </div>

      <div class="text-center text-0625">
        <div v-if="order">OID: {{ order._id }}</div>
        <div v-if="fid">FID: {{ fid }}</div>
        <div v-if="cid">CID: {{ cid }}</div>
      </div>
    </div>

    <slot name="post_footer"></slot>

  </q-layout>
</template>

<style>
.q-focus-helper {
  background: none !important;
}

.q-btn-dropdown__arrow {
  display: none;
}

.user_menu_item {

}

.user_menu_item:hover {
  background-color: #f3f4f6;
}
</style>
